import {ColumnGrid, GridRow} from "./ColumnGrid";
import useAxiosRequest from "../hooks/useAxiosRequest";

import '../styles/PersonalMapList.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

import config from '../config.json';

const MapInfo = ({ map }) => {
    let {isLoading, data: template, error} = useAxiosRequest({
        url: `${config.backendUrl}/maps/templates/${map.template}`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading || error) return;

    return (
        <div className="MapInfo" onClick={() => window.location = '/maps?edit=' + map._id}>
            <ColumnGrid columns="1fr 1fr auto auto">
                <GridRow>
                    <span>{map.name}</span>
                    <span style={{ textAlign: 'left' }}>{template.name}</span>
                    <span>{new Date(map.lastModified).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric' })}</span>
                    <span style={{ marginLeft: '20px' }}><FontAwesomeIcon icon={faTrash}/></span>
                </GridRow>
            </ColumnGrid>
        </div>
    );
}

const PersonalMapList = () => {
    let {isLoading, data: maps, error} = useAxiosRequest({
        url: `${config.backendUrl}/maps`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading || error) return;

    return (
        <div className="PersonalMapList" style={{ display: maps.length ? '' : 'none' }}>
            <span className="title">Personal Maps</span>
            {maps.map(map => <MapInfo key={map._id} map={map}/>)}
        </div>
    );
}

export default PersonalMapList;
